import React, { useState, useEffect } from "react";

import cube from "services/cube";
import { Form, Loading } from "components";

const DEFAULT_FILTERS = {
  regions: [],
};

export function Stores({
  onChange,
  value,
  isDisabled,
  isMulti = false,
  filters = DEFAULT_FILTERS,
}) {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!loading) {
      setLoading(true);
    }

    const filteredRegions = filters.regions
      .filter((region) => region)
      .map((region) => region.value);

    const params = {
      region_ids: filteredRegions.length ? filteredRegions : null,
    };

    cube
      .get("/list/stores", { params })
      .then((response) => setStores(response.data))
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  }, [filters.regions]);

  return (
    <>
      <Form.Select
        isMulti={isMulti}
        placeholder="Todas"
        value={value}
        onChange={onChange}
        isDisabled={isDisabled}
        options={stores.map((store) => ({
          value: store.id,
          label: store.name,
        }))}
      />

      {loading && <Loading type="filter" />}
    </>
  );
}
